// Navy Professional design
const NavyProfessionalDesign = {
  id: 'navy-professional',
  name: 'Navy',
  category: 'professional', // New category
  description: 'Classic navy blue scheme for corporate roles',
  colors: {
    primary: "#001f3f",    // Dark Navy
    secondary: "#607D8B",  // Medium Blue/Grey
    tertiary: "#B0BEC5",   // Light Grey
    quaternary: "#ECEFF1", // Off-white/Very Light Grey
    accent1: "#001f3f",    // Dark Navy (repeat for consistency)
    accent2: "#607D8B",    // Medium Blue/Grey
    // Add other accents if needed, maybe lighter blues or greys
    text: "#263238",       // Dark Grey/Near Black Text
    textSecondary: "#546E7A", // Medium Grey Secondary Text
    background: "#ffffff", // White background
    sidebarBackground: "#ECEFF1", // Very Light Grey sidebar
    border: "#ffffff",     // Light Grey border
  },
  // Optional: Define specific typography if needed, otherwise it might inherit defaults
};

export default NavyProfessionalDesign; 